import authenticatedRoute from '@/views/AuthenticatedRoute';
import { Box, Paper, Typography } from '@mui/material';
import React from 'react';
import { constants } from '@/constants';
var TermsOfUse = function TermsOfUse() {
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            pb: '56px'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        sx: {
            color: '#212121',
            textAlign: 'left',
            m: 3
        }
    }, constants.terms_of_use_title), /*#__PURE__*/ React.createElement(Paper, {
        elevation: 1,
        sx: {
            p: 3,
            mx: 3,
            backgroundColor: '#ffffff'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mb: 4
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            mb: 2
        }
    }, constants.terms_of_use_intro)), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mb: 4
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        fontWeight: 600,
        sx: {
            mb: 2
        }
    }, constants.terms_of_use_content_heading), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            mb: 2
        }
    }, constants.terms_of_use_content_para1), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            mb: 2
        }
    }, constants.terms_of_use_content_para2), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1"
    }, constants.terms_of_use_content_para3)), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mb: 4
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        fontWeight: 600,
        sx: {
            mb: 2
        }
    }, constants.terms_of_use_disclaimers_heading), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            mb: 2
        }
    }, constants.terms_of_use_disclaimers_para1), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            mb: 2
        }
    }, constants.terms_of_use_disclaimers_para2), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            mb: 2
        }
    }, constants.terms_of_use_disclaimers_para3), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1"
    }, constants.terms_of_use_disclaimers_para4)), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mb: 4
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        fontWeight: 600,
        sx: {
            mb: 2
        }
    }, constants.terms_of_use_additional_heading), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            mb: 2
        }
    }, constants.terms_of_use_additional_para1), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1"
    }, constants.terms_of_use_additional_para2))));
};
export default authenticatedRoute(TermsOfUse);
